module.exports = __webpack_public_path__ + "img/df-etichetta.b859de0f.png";